<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>Pick Wave</v-toolbar-title>
                        <v-spacer />
                        <template v-slot:extension>
                            <v-tabs v-model="tabs">
                            <v-tab>New</v-tab>
                            <v-tab>Finished</v-tab>
                            </v-tabs>
                        </template>
                    </v-toolbar>
                    <v-tabs-items v-model="tabs">
                        <v-tab-item>
                            <v-data-table
                                :items="newPickwaves"
                                :headers="headers"
                            >
                                <template v-slot:item.actions="{item}">
                                    <v-btn :to="'/pickwave/'+item.id">{{item.start_date ? 'Resume':'Start'}}</v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                                :items="finishPickwaves"
                                :headers="headers"
                            >
                                <template v-slot:item.actions="{item}">
                                    <v-btn :to="'/pickwave/'+item.id">View</v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    data:() => ({
        tabs:0,
        headers:[
            { text: "Id", value: "id" },
            { text: "Picker", value: "picker_id" },
            { text: "Start Date", value: "start_date" },
            { text: "End Date", value: "end_date" },
            { text: "Status", value: "status" },
            { text: "Actions", value: "actions" },
        ]
    }),
    mounted(){
        this.initialize();
    },
    computed:{
        ...mapGetters("pickwave", ["pickWaves", "loading"]),
        newPickwaves(){
            return this.pickWaves.filter(p => p.end_date == null);
        },
        finishPickwaves(){
            return this.pickWaves.filter(p => p.end_date != null);
        },
    },
    methods:{
        ...mapActions("pickwave", ["getPickWaves"]),
        initialize(){
            this.getPickWaves();
        }
    }
}
</script>

<style>

</style>